import { useEffect } from 'react';

// Compteur partagé au niveau module : plusieurs surfaces peuvent verrouiller
// le scroll en même temps (menu burger -> modale, modale -> confirmation de
// suppression). Le body n'est déverrouillé que par le dernier verrou levé.
let lockCount = 0;
let savedScrollY = 0;
let savedStyles = null;

function applyLock() {
  if (lockCount++ > 0) return;

  const body = document.body;
  savedScrollY = window.scrollY || window.pageYOffset || 0;

  // `overflow: hidden` seul ne bloque pas iOS Safari : on fige le body en
  // `position: fixed` décalé du scroll courant, restauré au déverrouillage.
  savedStyles = {
    position: body.style.position,
    top: body.style.top,
    left: body.style.left,
    right: body.style.right,
    width: body.style.width,
    overflow: body.style.overflow,
    paddingRight: body.style.paddingRight,
  };

  // Compense la disparition de la scrollbar (desktop) pour éviter que le
  // contenu sous l'overlay ne se décale horizontalement.
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

  body.style.position = 'fixed';
  body.style.top = `-${savedScrollY}px`;
  body.style.left = '0';
  body.style.right = '0';
  body.style.width = '100%';
  body.style.overflow = 'hidden';
  if (scrollbarWidth > 0) {
    const current = parseFloat(window.getComputedStyle(body).paddingRight) || 0;
    body.style.paddingRight = `${current + scrollbarWidth}px`;
  }
}

function releaseLock() {
  if (lockCount === 0) return;
  if (--lockCount > 0) return;

  const body = document.body;
  if (savedStyles) {
    body.style.position = savedStyles.position;
    body.style.top = savedStyles.top;
    body.style.left = savedStyles.left;
    body.style.right = savedStyles.right;
    body.style.width = savedStyles.width;
    body.style.overflow = savedStyles.overflow;
    body.style.paddingRight = savedStyles.paddingRight;
    savedStyles = null;
  }
  window.scrollTo(0, savedScrollY);
}

/**
 * Verrouille le scroll du <body> tant que `active` est vrai.
 * Ré-entrant : gère l'empilement de surfaces modales.
 */
export default function useBodyScrollLock(active) {
  useEffect(() => {
    if (!active) return undefined;
    applyLock();
    return releaseLock;
  }, [active]);
}
